import Vue from 'vue';
import types from './mutation-types';


const mutations = {
  [types.SET_ADVERTISEMENT](state, value) {
    Vue.set(state, 'advertisement', value);
  },
};

export default mutations;



// WEBPACK FOOTER //
// ./src/app/advertisements/store/mutations.js